import { useQuery } from "@tanstack/react-query"
import type { InferResponseType } from "hono/client"
import { apiClient, getData } from "../../lib/apiClient"

const req = apiClient.auth.me.$get
type AuthenticatedUserMe = InferResponseType<typeof req, 200>
export type UserMe = AuthenticatedUserMe | { user: null }

export const useUserMe = ({ enabled = true }: { enabled?: boolean } = {}) =>
	useQuery({
		enabled,
		queryKey: ["user", "me"],
		queryFn: async () => {
			const response = await apiClient.auth.me.$get()
			if (response.status === 401) {
				return { user: null }
			}

			return getData(response)
		},
		retry: false,
	})
